import { render, staticRenderFns } from "./localUserAddress.vue?vue&type=template&id=67eac5f6&scoped=true&"
import script from "./localUserAddress.vue?vue&type=script&lang=js&"
export * from "./localUserAddress.vue?vue&type=script&lang=js&"
import style0 from "./localUserAddress.vue?vue&type=style&index=0&id=67eac5f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eac5f6",
  null
  
)

export default component.exports